var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMatchingLines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 52,
    viewBox: "0 0 67 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    fill: "#2CABE0",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 10,
    transform: "translate(-91 -861) translate(60 829) translate(31 32)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 10
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 23
  }, "b"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 36
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 49
  }, "d")), /*#__PURE__*/React.createElement("text", {
    fill: "#2CABE0",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 10,
    transform: "translate(-91 -861) translate(60 829) translate(31 32)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 61,
    y: 10
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 61,
    y: 23
  }, "2"), /*#__PURE__*/React.createElement("tspan", {
    x: 61,
    y: 36
  }, "3"), /*#__PURE__*/React.createElement("tspan", {
    x: 61,
    y: 49
  }, "4")), /*#__PURE__*/React.createElement("path", {
    stroke: "#2CABE0",
    strokeLinecap: "square",
    d: "M11.5 43.5L57.5 10.5M11.5 10.5L57.5 18.5M11.5 18.5L55.5 43.5M11.5 32.5L57.5 32.5",
    transform: "translate(-91 -861) translate(60 829) translate(31 32)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchingLines);
export default __webpack_public_path__ + "static/media/matching-lines.ed9b59f22d8eaca6e04c9b9751d93441.svg";
export { ForwardRef as ReactComponent };